import * as THREE from 'three';
import { View3dGlobal } from '..';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export class GLTFHouseLoader {

  private glb: THREE.Group;
    /* loadHouse
     * 家本体のデータの読込.
     */
    public load(data: ArrayBuffer | string) {
        const loader = new GLTFLoader();
        // gltf データをパース
        loader.parse(data, View3dGlobal.shared.baseURL,
          (gltf: GLTF) => {
            this.glb = gltf.scene;
          },
          (event: ErrorEvent) => {
            ;
          }
        );
        return this.glb;
    }

    public loadAsync(data) {
      const loader = new GLTFLoader();
      return loader.parseAsync(data, View3dGlobal.shared.baseURL);
    }
}
